// Function to validate Bitcoin addresses
export const isBitcoinAddress = (address: string): boolean => {
    // From binance
    const bitcoinAddressRegex = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[(bc1q)|(bc1p)][0-9A-Za-z]{37,62}$/

    return bitcoinAddressRegex.test(address)
}
